<template>
  <div role="message" class="base-message-box my-2 el-message flex flex-col gap-1" :class="boxClass">
    <header v-if="hasHeader" class="flex w-full items-center">
      <base-icon v-if="iconName" class="el-message__icon" size="xsm" :name="iconName" :class="iconClass" />
      <i v-else-if="iconClass" class="el-message__icon" :class="iconClass"></i>
      <span class="el-message__content flex text-sm w-full">
        <slot name="header" />
      </span>
    </header>
    <main v-if="hasContent || needIconContent" class="flex w-full items-center">
      <template v-if="needIconContent">
        <base-icon v-if="iconName" class="el-message__icon" :name="iconName" :class="iconClass" />
        <i v-else-if="iconClass" class="el-message__icon" :class="iconClass"></i>
      </template>
      <section v-if="hasContent" class="el-message__content flex flex-col text-xs w-full">
        <slot name="content" />
        <slot />
      </section>
    </main>
  </div>
</template>
<script>
import MessageType from '@/classes/enums/MessageType'
import iconLibraryNames from '@/components/icons/_iconLibrary'
export default {
  name: 'base-message-box',
  props: {
    type: {
      type: String,
      default: MessageType.INFO,
      validator: value => Object.values(MessageType).includes(value)
    },
    iconClass: String,
    iconName: {
      type: String,
      validator: value => !value || iconLibraryNames.includes(value)
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    hasIcon: function () {
      return !!(this.iconClass || this.iconName)
    },
    hasHeader: function () {
      return !!(this.$slots.header || this.$scopedSlots.header)
    },
    hasContent: function () {
      return !!(this.$slots.content || this.$scopedSlots.content || this.$slots.default || this.$scopedSlots.default)
    },
    needIconContent: function () {
      return !!(this.hasIcon && !this.hasHeader)
    },
    finalType: function () {
      switch (this.type) {
        case MessageType.SUCCESS:
        case MessageType.WARNING:
        case MessageType.ERROR:
        case MessageType.INFO:
          return this.type
        default:
          return MessageType.INFO
      }
    },
    boxClass: function () {
      return [
          `el-message--${this.finalType}`
      ]
    }
  }
}
</script>
<style scoped>
.el-message {
  position: relative;
  transform: none;
  left: auto;
  top: auto;
  transition: none;
  z-index: inherit !important;
}

@media (max-width: 640px) {
  .el-message {
    min-width: 0px;
  }
}
</style>
